import React, { useState } from "react";
import { Plus } from "lucide-react";

interface InsertComponentLineProps {
  position: number;
  onInsert: (position: number) => void;
}

export const InsertComponentLine: React.FC<InsertComponentLineProps> = ({
  position,
  onInsert,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="relative py-2 group cursor-pointer"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => onInsert(position)}
    >
      {/* Horizontal line */}
      <div
        className={`
          absolute left-4 right-4 top-1/2 -translate-y-1/2
          h-[2px] rounded-full
          transition-all duration-200 ease-out
          ${isHovered 
            ? "bg-blue-400 opacity-80" 
            : "bg-gray-300 opacity-40"
          }
        `}
      />
      
      {/* Center plus button */}
      <div className="relative flex justify-center">
        <button
          type="button"
          className={`
            flex items-center justify-center
            rounded-full border-2
            transition-all duration-200 ease-out
            ${isHovered
              ? "w-8 h-8 bg-blue-500 border-blue-500 text-white shadow-md scale-110"
              : "w-6 h-6 bg-white border-gray-300 text-gray-400 shadow-sm"
            }
          `}
          onClick={(e) => {
            e.stopPropagation();
            onInsert(position);
          }}
          title="Insert component here"
        >
          <Plus
            size={isHovered ? 18 : 14}
            className="transition-all duration-200"
          />
        </button>
      </div>
    </div>
  );
};



